<template>
  <div class="chats-container">
    <div class="sidebar">
      <TelegramChats />
    </div>
    <div class="chat-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import TelegramChats from '@/components/TelegramChats.vue';

export default {
  name: 'ChatsView',
  components: {
    TelegramChats
  }
}
</script>

<style scoped>
.chats-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.sidebar {
  width: 300px;
  border-right: 1px solid #e0e0e0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chat-content {
  flex: 1;
  overflow: auto;
}

@media (max-width: 768px) {
  .sidebar {
    width: 250px;
  }
}
</style> 